import React from 'react'

function About() {
    return (
        <div name="about" className='w-full h-screen bg-[#0a192f] text-gray-300'>
            {/* Container */}
            <div className="flex flex-col justify-center items-center w-full h-full">
                <div className='sm:text-left pb-8 pl-4'>
                    <p className='text-4xl font-bold inline border-b-4 border-pink-600'>About Me</p>
                </div>
                {/* Grid of 2 columns */}
                <div className='max-w-[900px] w-full grid sm:grid-cols-2 gap-6 px-8'>
                    {/* Left Box */}
                    <div className='sm:text-center text-3xl font-bold md:text-right'>
                        <p>Thank You for visiting the website. <br /> Please have a look around.</p>
                    </div>
                    {/* Right Box */}
                    <div>
                        <p>I’m ambitious, hard-working, and detail-oriented kind of a person who likes to study and learn new things.
                            <br></br>I’m always energetic about seeking new opportunities to develop and I try to gain more knowledge in things which interests me. </p>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default About